import React , {useEffect, useState} from 'react'; 
import '../assets/css/custom.css'; 
import '../assets/css/client.css'; 
import '../assets/css/font-awesome.css';
import '../assets/css/sweetalert.css';
import '../assets/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { faEdit, faPlus, faSort, faTrash, faEllipsisVertical, faTrashCan, faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-bootstrap/Modal';
import NoBuilding from "../assets/img/no-flat.png";
import {commonAPI} from "../services/CommonAPIService"
import {ErrorSource} from '../common/constants'
import Menus from "./menus";
import Button from 'react-bootstrap/Button';
import stopMark from '../assets/img/stop.png';
import bike from '../assets/img/bike.png';
import FlatIcon from '../assets/img/no-flat.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-select-search/style.css'
import Select from "react-dropdown-select";




function Flat()  { 
    const [DeleteShow, setDeleteShow] = useState(false);
    const [show, setShow] = useState(false);
    const [FlatList, setFlatList] = useState("");
    const [TowerList, setTowerList] = useState("");
    const [FlatId, setFlatId] = useState("");
    const [FlatName, setFlatName] = useState("");
    const [TowerId, setTowerId] = useState("");
    const [TowerIdSelect, setTowerIdSelect] = useState("");
    const [FloorName, setFloorName] = useState("");
    const [FloorCmd, setFloorCmd] = useState("");
    const [Seq, setSeq] = useState("");
    const [Loading, setLoading] = useState(false);
    const [UserData, setUserData] = useState("");
    const [AddFlatBtn, setAddFlatBtn] = useState(false);
    const [UpdateFlatBtn, setUpdateFlatBtn] = useState(false);
    const [oldVehicleIndex,setOldVehicleIndex] = useState(null)
    const [vehicleMenu,showVehicleMenu] = useState(null)
    const [BuildingList, setBuildingList] = useState("");
    const [BuildingId, setBuildingId] = useState("");
    const [SelectedFlatId, setSelectedFlatId] = useState("");
    console.log("TowerIdSelect", TowerIdSelect)
    
    const setInputValue = (item) => {
        setShow(true)
        setAddFlatBtn(false)
        setUpdateFlatBtn(true)
        setFlatId(item?.flatId)
        // console.log("item", item)
        setFlatName(item?.flatName);
        setTowerId(item?.towerId);
        setFloorName(item?.floorNumber);
        setFloorCmd(item?.floorCmd);
        setSeq(item?.seq);
    };

    const openCreateModal = () => {
        if(!BuildingId){
            toast.warning("Please select Building");
        }else if(!TowerIdSelect){
            toast.warning("Please select Tower");
        }else{
            setShow(true)
            setAddFlatBtn(true)
            setUpdateFlatBtn(false)
            setFlatName("");
            setTowerId(TowerIdSelect);
            setFloorName("");
            setFloorCmd("");
            setSeq("");
        }    
    };
    
    
    const GetBuildingList = async () => {
        const auth2 = localStorage.getItem("primeProductCode");
        const ProductfactorKey = JSON.parse(auth2);
        const endPointVariableKey = {
            ProductId: ProductfactorKey?.primeProductCode,
        }
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        setUserData(myUserData);
        try {
            // setLoading(true);
            let response = await commonAPI("BuildingLite", undefined, endPointVariableKey)
            if (response?.success===true){
                setBuildingList(response?.data);
                setLoading(false);
            }else{
                toast.error("Something went wrong");
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            const bodyError = { 
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/Master/Building",
                "errorNumber": "BL01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "flat.js",
                "functionName": "GetBuildingList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    } 
    
    

    const GetFlatList = async () => {

        try {
            setLoading(true);
            const BuildingAuth = localStorage.getItem("BuildingId");
            const myBuildingId = JSON.parse(BuildingAuth);
            const endPointVariableKey    = {
                urlVariable:null,
                buildingId: myBuildingId
            
            }
            let response = await commonAPI("Flat", undefined, endPointVariableKey);
            if (response?.success===true){
                const tempData = response?.data.filter((item)=> item?.towerId == TowerIdSelect)
                setFlatList(tempData);
                setLoading(false);
            }else{
                toast.error("Something went wrong");
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            // console.log(myUserData)
            setUserData(myUserData);
            console.log("UserData", UserData)
            const bodyError = JSON.stringify({ 
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/Master/Flat",
                "errorNumber": "GF01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "flat.js",
                "functionName": "getFlatList",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }  

    const GetTowerList = async () => {

        try {
            // setLoading(true);
            // const BuildingAuth = localStorage.getItem("BuildingId");
            // const myBuildingId = JSON.parse(BuildingAuth);
            // if(myBuildingId){
                const endPointVariableKey    = {
                    urlVariable:null,
                    buildingId: BuildingId
                
                }
                // setLoading(true);
                let response = await commonAPI("Tower", undefined, endPointVariableKey)
                if (response?.success===true){
                    // console.log("TowerApi!!!", myBuildingId);
                    console.log("TowerApi!!!111", response?.data);
                    // await localStorage.setItem("BuildingId", BuildingId.toString());
                    setTowerList(response?.data);
                    setLoading(false);
                }else{
                    toast.error("Something went wrong");
                    setLoading(false);
                }
            // }
            // else{
            //     const endPointVariableKey    = {
            //         urlVariable:null,
            //         buildingId: BuildingId
                
            //     }
            //     setLoading(true);
            //     let response = await commonAPI("Tower", undefined, endPointVariableKey)
            //     if (response.success===true){
            //         console.log("TowerApi222", BuildingId);
            //         console.log("TowerApi!!!3333", response.data);
            //         await localStorage.setItem("BuildingId", BuildingId.toString());
            //         setTowerList(response.data);
            //         setLoading(false);
            //     }else{
            //         toast.error("Something went wrong");
            //         setLoading(false);
            //     }
            // }
            

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = { 
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/Master/Tower/",
                "errorNumber": "GT01",
                "errorSource": "CuroNextPortal",
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "flat.js",
                "functionName": "GetTowerList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }

    useEffect(() => {        
        (async function(){
            const BuildingAuth = localStorage.getItem("BuildingId");
            const myBuildingId = JSON.parse(BuildingAuth);
            if(myBuildingId){
                setBuildingId(myBuildingId);
                setTowerIdSelect("");
                console.log("building Id", myBuildingId)
            }    
        })()
    }, [])

    useEffect(() => {
        if(BuildingId){
            GetTowerList();
            setTowerIdSelect("");
            (async function(){
                await localStorage.setItem("BuildingId", BuildingId);
            })()
        }else if (BuildingId == ""){
            setTowerList("");
            setFlatList("")
        }
    }, [BuildingId])

    useEffect(() => {
        if(TowerIdSelect){
            GetFlatList();
            setFlatList("")
        }else {
            setFlatList("")
        }
    }, [TowerIdSelect])

    

    const addNewFlat = async () => {
        const bodyData = {
            flatName: FlatName,
            towerId: TowerIdSelect,
            floorNumber: FloorName,
            floorCmd: FloorCmd,
            seq: Seq,
            createdUserId: JSON.stringify(UserData?.userId),
        }
        try {
            setLoading(true);
            if(!FlatName){
                toast.warning("Please enter Flat Number");
                setLoading(false);
            }else if (!FloorName){
                toast.warning("Please enter Floor Number");
                setLoading(false);
            }else if(!Seq){
                toast.warning("Please enter Sequence");             
                setLoading(false);
            }else{
                setLoading(true);
                const BuildingAuth = localStorage.getItem("BuildingId");
                const myBuildingId = JSON?.parse(BuildingAuth);
                const endPointVariableKey    = {
                    urlVariable:null,
                    buildingId: myBuildingId
                
                }
                setLoading(true);
                let response = await commonAPI("FlatAdd", bodyData, endPointVariableKey)
                console.log(response);
                if(response?.success === true){
                    toast.success("Flat Added"); 
                    setLoading(false);
                    setShow(false);
                    GetFlatList();
                }else{
                    toast.error(response.message[0]);
                    setLoading(false);
                }
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = { 
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "/api/Master/Flat",
                "errorNumber": "GT01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "flat.js",
                "functionName": "addNewFlat",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
      };

      const UpdateFlat = async () => {
        const bodyData = {
            flatId: FlatId,
            flatName: FlatName,
            towerId: TowerIdSelect,
            floorNumber: FloorName,
            floorCmd: FloorCmd,
            seq: Seq,
            modifiedUserId: JSON.stringify(UserData?.userId),
        }
        try {
            setLoading(true);
            
            if(!FlatName){
                toast.warning("Please enter Flat Number");
                setLoading(false);
            }else if (!FloorName){
                toast.warning("Please enter Floor Number");
                setLoading(false);
            }else if(!Seq){
                toast.warning("Please enter Sequence");             
                setLoading(false);
            }else{
                const BuildingAuth = localStorage.getItem("BuildingId");
                const myBuildingId = JSON.parse(BuildingAuth);
                const endPointVariableKey    = {
                    urlVariable:null,
                    buildingId: myBuildingId
                
                }
                let response = await commonAPI("FlatUpdate", bodyData, endPointVariableKey)
                console.log(response);
                if(response?.success === true){
                    toast.success("Flat Updated"); 
                    console.log(response?.success)
                    setLoading(false);
                    setShow(false);
                    GetFlatList();
                }else{
                    toast.error(response?.message[0]);
                    setLoading(false);
                }
            }    

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = JSON.stringify({ 
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "api/Master/Flat",
                "errorNumber": "UF01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "flat.js",
                "functionName": "UpdateFlat",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
      };

    const ShowDeleteModal = (item) => {
        setDeleteShow(true);
        setSelectedFlatId(item)

    }

    const DeleteFlat = async () => {
        let bodyData = { 
            "flatid": SelectedFlatId?.flatId,
            "modifiedUserId": JSON.stringify(UserData?.userId), 
          };
        try {
            setLoading(true);
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            console.log(myUserData)
            const BuildingAuth = localStorage.getItem("BuildingId");
            const myBuildingId = JSON.parse(BuildingAuth);
            //   console.log("body", bodydata);
            const endPointVariableKey    = {
                urlVariable:null,
                buildingId: myBuildingId
            
            }
              let response = await commonAPI("FlatDelete", bodyData, endPointVariableKey)
              console.log("statusCode", response)
              if(response?.success === true && response?.message?.length == 0){
                toast.success("Flat Deleted"); 
                setLoading(false); 
                GetFlatList();
                setDeleteShow(false);
              }else{
                toast.error(response?.message[0]);
                setLoading(false);
              }
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = JSON.stringify({ 
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "api/Master/Flat",
                "errorNumber": "DF01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "flat.js",
                "functionName": "DeleteFlat",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
          
    }

    

    function setVehicleIndex(index) {
        console.log(oldVehicleIndex == index, "oldVehicleIndex==index")
        if (oldVehicleIndex == index) {
            setOldVehicleIndex(null)
            showVehicleMenu(null)

        }
        else {
            showVehicleMenu(index)
            setOldVehicleIndex(index)

        }
        // setHideVehicleMenu(true)
    }  


    useEffect(() => {
        GetBuildingList();
    }, [])

    const options = TowerList
    ? TowerList.map(item => ({
        value: item.towerId, // Use towerId as value
        label: item.towerName, // Use towerName as label
      }))
    : [];
    

     return (
    <>
    {Loading? 
        <div className="loaderDiv">
          <div className="loader"></div>
        </div> 
      :null}
      {/* <Menus/> */}
      <ToastContainer />
      <div className="row mt-5 pt-5" style={{alignItem:'center'}}>
            <div className="col-lg-6 col-md-6">
                <div className="HeadingTop">
                    <h3> Flats </h3>
                    <span> Maintain and create flats with their complete details.</span>
                </div>
            </div>
            <div className="col-lg-6 col-md-6 mb-3 mb-md-0 text-right" style={{alignSelf:'center', display: "ruby"}}>
                <select size="md" className="sltareamodal col-3 ml-auto" style={{height: 37}} value={BuildingId} onChange={(e) => {
                    console.log("selection", e.target.value)
                    setBuildingId(e.target.value);}}>
                    <option value="">Select Building</option>
                    {BuildingList ? BuildingList?.map((item, index) =>  <option key={index} value={item?.buildingId}>{item?.buildingName}</option>): null}
                </select>
                {/* <select size="md" className="sltareamodal col-3 ml-auto" value={TowerIdSelect} onChange={(e) => {
                    console.log("selection", e.target.value)
                    setTowerIdSelect(e.target.value);}}>
                    <option value="">Select Tower</option>
                    {TowerList ? TowerList?.map((item, index) =>  <option key={index} value={item?.towerId}>{item?.towerName}</option>): null}
                </select> */}
                     
                   <Select
                        isSearchable={true}
                        clearable={true}
                        options={options}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        className="sltareamodal"
                        onChange={(selected) => setTowerIdSelect(selected && selected.length > 0 ? selected[0].value : '')}
                        style={{
                            fontSize: '13px',
                            borderColor: '#ccc',
                            borderRadius: '4px',
                            height: '30px',
                            width: '150px',
                            backgroundColor: 'gainsboro',
                            textAlign: 'left',
                        }}
                        dropdownStyle={{
                            width: '200px',
                        }}
                        placeholder="Search towers..."
                        filterOption={(option, inputValue) =>
                            option.label.toLowerCase().includes(inputValue.toLowerCase())
                        }
                    />

                    
                {/* <SelectSearch
                    options={
                        TowerList
                            ? TowerList.map((item) => ({
                                value: item.towerId,
                                label: item.towerName,
                            }))
                            : []
                    }
                    onChange={(selectedValues) => {
                        setTowerIdSelect(selectedValues);
                        console.log("Selected Tower:", selectedValues);
                    }}
                    placeholder="Select Tower"
                    search
                    className=""
                    /> */}

                <Button variant="btn btn-info" onClick={() => openCreateModal()}>+ Create New </Button>{' '}
            </div>
        </div>
      


            <Modal size="md" show={show} onHide={() => setShow(false)} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="example-modal-sizes-title-md">
        <Modal.Header closeButton className='headerMDL'>
          <Modal.Title id="example-modal-sizes-title-md">
            {/* Add New Flat */}
            {UpdateFlatBtn ?   <>Update Flat</> : <>Add Flat</> }
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="helpingElelemnt_uuy002">
          
                        
                      <div className="row" id="validation">
                    <div className="col-12">
                  
                             
                         
                                <form action="#" className="validation-wizard wizard-circle wizard clearfix" role="application" id="steps-uid-2" novalidate="novalidate">
                                    
                                        <div className="content clearfix">
                                     
                                    <h6 id="steps-uid-2-h-0" tabIndex="-1" className="title current"> </h6>
                                    <section id="steps-uid-2-p-0" role="tabpanel" aria-labelledby="steps-uid-2-h-0" className="body current" aria-hidden="false">
                                        <div className="row text-left">
                                        <div className="col-md-6 mb-2">
                                                <div className="form-group">
                                                    <label for="wlastName2"> Tower Name  </label>
                                                    <select name="taskTypes" id="wlastName2" disabled className="form-control" value={TowerId} onChange={(e)=>{setTowerId(e.target.value)}}>
                                                        <option value="Select">Select</option>
                                                        {TowerList ? TowerList?.map((item, index) =>  <option key={index} value={item?.towerId}>{item?.towerName}</option>): null}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <div className="form-group">
                                                    <label for="wfirstName2"> Flat Number  <span className="danger">*</span> </label>
                                                    <input type="text" value={FlatName} onChange={(e)=>{setFlatName(e.target.value)}} className="form-control required" id="wfirstName2" name="firstName" aria-required="true" /> </div>
                                            </div>
                                            
                                            <div className="col-md-6 mb-2">
                                                <div className="form-group">
                                                    <label for="wfirstName2"> Floor Number  <span className="danger">*</span> </label>
                                                    <input type="number" value={FloorName} onChange={(e)=>{setFloorName(e.target.value)}} className="form-control required" id="wfirstName2" name="firstName" aria-required="true" /> </div>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <div className="form-group">
                                                    <label for="wlastName2"> Floor Cmd  </label>
                                                    <input type="text" value={FloorCmd} onChange={(e)=>{setFloorCmd(e.target.value)}} className="form-control required" id="wlastName2" name="lastName" aria-required="true" /> </div>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <div className="form-group">
                                                    <label for="wlastName2"> Sequence  <span className="danger">*</span> </label>
                                                    <input type="number" value={Seq} onChange={(e)=>{setSeq(e.target.value)}} className="form-control required" id="wlastName2" name="lastName" aria-required="true" /> </div>
                                            </div>

                                        </div>  
                                    </section>
 
                                </div>
                                
                                <div className="actions clearfix">
                                   
                                    </div>
                                    </form>
                          
                        
                    </div>
                </div>
              
            
        </Modal.Body>

        <div className="fixed_allbtn">                        
              <div className="upload_btn">
              <ul role="menu" aria-label="Pagination"className='mb-0'>
                                        {AddFlatBtn ?  
                                            <div className="  align-self-start">
                                                <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
                                                <button type="button" className="btn btn-info" onClick={() => addNewFlat()}> Submit</button>
                                            </div>
                                            // <li aria-hidden="false" aria-disabled="false">
                                            //     <a onClick={addNewFlat} role="menuitem">Submit</a>
                                            // </li>
                                        :null}
                                        {UpdateFlatBtn ?  
                                            <div className="  align-self-start">
                                                <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
                                                <button type="button" className="btn btn-info" onClick={() => UpdateFlat()}> Update</button>
                                            </div>
                                            // <li aria-hidden="true" >
                                            //     <a onClick={UpdateFlat} role="menuitem">Update</a>
                                            // </li>
                                        :null}    
                                    </ul>
             
                                          </div>
 </div>

      </Modal>




  
          <div className="row">
                    <div className="col-12">
  
                                {/* <h6 className="card-subtitle">Export details to Copy, CSV, Excel, PDF & Print</h6> */}

                                 
                                    <div id="example23_wrapper" className="dataTables_wrapper pt-0">
                                        {/* <div className="dt-buttons">
                                            <a className="dt-button buttons-copy buttons-html5" tabIndex="0" aria-controls="example23" href="#">
                                            <span>Copy</span>
                                            </a>
                                            <a className="dt-button buttons-csv buttons-html5" tabIndex="0" aria-controls="example23" href="#">
                                                <span>CSV</span>
                                                </a>
                                                <a className="dt-button buttons-excel buttons-html5" tabIndex="0" aria-controls="example23" href="#"> 
                                                <span>Excel</span>
                                                </a>
                                                <a className="dt-button buttons-pdf buttons-html5" tabIndex="0" aria-controls="example23" href="#">
                                                    <span>PDF</span>
                                                </a>
                                                <a className="dt-button buttons-print" tabIndex="0" aria-controls="example23" href="#">
                                                    <span>Print</span>
                                                </a>
                                        </div> */}
                                        <div id="example23_filter" className="dataTables_filter">
                                                {/* <label>Search:<input type="search" className="" placeholder="" aria-controls="example23" />
                                                </label> */}
                                            </div>
                                            {/* <table id="example23" className="display nowrap table table-hover table-striped table-bordered dataTable" cellSpacing="0"  role="grid" aria-describedby="example23_info" style={{width: '100%'}}>
                                                <thead>
                                                    <tr role="row"> 
                                                    <th className="sorting" tabIndex="0" aria-controls="example23" rowSpan="1" colSpan="1" aria-label="Name: activate to sort column ascending" style={{width: '200px'}}>Seq</th>
                                                    <th className="sorting" tabIndex="0" aria-controls="example23" rowSpan="1" colSpan="1" aria-label="Name: activate to sort column ascending" style={{width: '200px'}}>Flat Number</th>
                                                    <th className="sorting" tabIndex="0" aria-controls="example23" rowSpan="1" colSpan="1" aria-label="Name: activate to sort column ascending" style={{width: '200px'}}>Floor Number</th>
                                                    <th className="sorting_asc" tabIndex="0" aria-controls="example23" rowSpan="1" colSpan="1" aria-label="Position: activate to sort column descending" style={{width: '50px'}} aria-sort="ascending">Tower Name <FontAwesomeIcon icon={faSort} className='sortclr' /></th>
                                                    <th className="sorting" tabIndex="0" aria-controls="example23" rowSpan="1" colSpan="1" aria-label="Name: activate to sort column ascending" style={{width: '200px'}}>Floor Cmd</th>
                                                

                                                    </tr>
                                                </thead>
                                        
                                                <tbody>
                                                    {FlatList ? FlatList.map((item, index) =>  
                                                        <tr role="row" key={index} className="odd">
                                                            <td>{item.seq}</td>
                                                            <td>{item.flatName}</td>
                                                            <td>{item.floorNumber}</td>
                                                            <td>{item.towerName}</td>
                                                            <td>{item.floorCmd}</td>
                                                            <td ><a onClick={() => setInputValue(item)}><FontAwesomeIcon icon={faEdit} className='editclr'/> </a></td>
                                                            <td ><a onClick={() => DeleteFlat(item)}><FontAwesomeIcon icon={faTrash} className='editclr' style={{color: "red"}}/> </a></td>
                                                        </tr>
                                                    ): null} 
                                                </tbody>
                                            </table> */}
                                            <div className="row">
                                                <div className="col-12">
    
                                 
                                                    <div id="example23_wrapper" className="dataTables_wrapper pt-0">                                        
                                                        <div className="row">
                                                        {TowerIdSelect ? (!FlatList?.length &&  FlatList?.length != null && 
                                                        <div className='bg-white' style={{paddingBottom:"50px", borderRadius: "10px"}}>
                                                            <div className='col-12 text-center'>
                                                                <img src={FlatIcon} alt="user" class="mx-auto mt-5" style={{height: "100px"}} />
                                                            </div>    
                                                            <br />
                                                            <h3 className='col-12 text-center NoDataShowTextColor' style={{marginTop: "0px"}}> No Flat Found</h3>
                                                            <h5 className='col-12 text-center NoDataShowTextColor' style={{marginTop: "10px"}}> Click on Create New button to add a Flat</h5>
                                                        </div>) :null}
                                                        {FlatList
                                                            ? FlatList?.map((item, index) => (
                                                            <div className="col-lg-3 col-md-6 col-sm-12 col-12" key={index}>
                                                                <div className="clientTiles" style={{height:145}}>
                                                                    <div className="ClientImg">
                                                                        <div className="tabs_img">
                                                                        <img src={FlatIcon} class="img img-responsive" alt="client-img" />
                                                                        </div>
                                                                        <div class="bars_font">
                                                                            <h3 className="font_trigger" onClick={() => {setInputValue(item);}} >
                                                                                <FontAwesomeIcon icon={faPenToSquare} />
                                                                            </h3>
                                                                            <h3 className="font_trigger" onClick={() => {ShowDeleteModal(item);}}>
                                                                                <FontAwesomeIcon icon={faTrashCan} />
                                                                            </h3>
                                                                        </div>
                                                                    </div>
                                                                    <div className="ClientText">
                                                                        <div className="l-two">
                                                                            <h1>{item?.flatName} </h1>
                                                                            <div className='row'>
                                                                                <div className='col-6'>
                                                                                    <h4>Floor  :  {item?.floorNumber} </h4>
                                                                                </div>
                                                                                <div className='col-6'>
                                                                                    <h4>Tower Name  :  {item?.towerName}</h4>
                                                                                </div>
                                                                                {/* <div className='col-6'>
                                                                                    <h4>Tower Name :{item.towerName}</h4>
                                                                                </div> */}
                                                                            </div>
                                                                            {/* <h4>{item.floorCmd}</h4> */}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            ))
                                                            : null}
                                                        </div>
                                                    </div>
                                        
                                            
                                                </div>
                                            </div>
                                </div>
                        
 
            </div>
        </div>
        <Modal centered show={DeleteShow} onHide={() =>
            setDeleteShow(false)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
                {/* <Modal.Header className="headerMDL" closeButton>
                    <Modal.Title id="contained-modal-title-vcenter" centered onClick={openCreateModal}>
                        <h4 className="mb-0"> Delete Flat </h4>
                    </Modal.Title>
                </Modal.Header> */}
                <Modal.Body className='p-0' style={{borderRadius: "10px", overflow: "hidden"}}>
                    <div className="row px-3" id="validation">
                        <div className="col-12 bg-white pt-3 pb-2">
                            <div className="FnFItem" style={{justifyContent: "flex-start"}}>
                            {/* <div className="FnFimg">
                                <img src={stopMark} className='img img-fluid img-responsive'  alt="placeholder" />
                            </div> */}
                            <div className="FnFtxt">
                                <h2> Delete Flat </h2>
                                <h3> Are you sure you want to delete? </h3>
                            </div>
                            </div>
                            
                        </div>
                        
                    </div>
                    <div className='confirmation_btn pb-4 pt-3 px-3' style={{justifyContent: "center", borderTop: "1px solid #dadada"}}>
                            <div className='both_ConfrmBTN col-6' onClick={() => DeleteFlat()}>
                                <Button variant="danger">Delete</Button>{' '}
                            </div>
                            <div className='both_ConfrmBTN col-6' onClick={() => setDeleteShow(false)} >
                                <Button variant="light"> Cancel</Button>{' '}
                            </div>
                        </div>
                </Modal.Body>
            </Modal>                                                   
 
       

        </>)

}
export default Flat